import {getCompanyId} from '@onviobr/services/session';
import {getRoute} from '@onviobr/services/environment';
import {jsonHeaders, throwOn} from '@onviobr/services/utils';

/* istanbul ignore next */
export async function getPasswordExpiration(): Promise<number> {
	const companyId = await getCompanyId();
	const base = await getRoute('CompanySettingServices');
	const url = `${base}/v1/password-expiration-setting/${companyId}`;
	let response = await fetch(url, {
		headers: jsonHeaders(),
		method: 'GET'
	});
	response = await throwOn(response, status => status >= 500);
	if (response.status === 404) {
		return Promise.resolve(90); // Default if unable to find setting
	}
	return response.json().then(body => body.maxPasswordAge);
}

/* istanbul ignore next */
export async function updatePasswordExpiration(pwdExpirationDays: number): Promise<Response> {
	const companyId = await getCompanyId();
	const base = await getRoute('CompanySettingServices');
	const url = `${base}/v1/password-expiration-setting/${companyId}`;
	let response = await fetch(url, {
		body: JSON.stringify({maxPasswordAge: pwdExpirationDays}),
		headers: jsonHeaders(),
		method: 'PUT',
	});
	response = await throwOn(response, status => status >= 500);
	return response;
}
